import { createReducer, Action, on } from '@ngrx/store';
import { onNgrxForms, createFormGroupState, formGroupReducer } from 'ngrx-forms';
import {
  INITIAL_STATE,
  CalendarConfigurationState,
  CALENDAR_CONGIFURATION_FORM_KEY
} from './calendar-configuration.declarations';
import * as calendarConfigurationActions from './calendar-configuration.actions';
import { CalendarConfiguration, DEFAULT_CALENDAR_CONFIGURATION } from '../../_models';
import { validateCalendarConfigurationForm } from './calendar-configuration.validators';

const reducer = createReducer<CalendarConfigurationState>(
  INITIAL_STATE,
  onNgrxForms(),
  /** init */
  on(calendarConfigurationActions.featureInitSuccess, (state, { calendarConfiguration }) => ({
    ...state,
    calendarConfigurationForm: createFormGroupState<CalendarConfiguration>(
      CALENDAR_CONGIFURATION_FORM_KEY,
      calendarConfiguration
    ),
    originalCalendarConfiguration: calendarConfiguration
  })),
  on(calendarConfigurationActions.featureInitError, state => ({ ...state })),
  /** state */
  on(calendarConfigurationActions.clearState, state => ({
    ...state,
    calendarConfigurationForm: createFormGroupState<CalendarConfiguration>(
      CALENDAR_CONGIFURATION_FORM_KEY,
      DEFAULT_CALENDAR_CONFIGURATION
    )
  }))
);

export function calendarConfigurationReducer(
  state: CalendarConfigurationState = INITIAL_STATE,
  action: Action
): CalendarConfigurationState {
  const calendarConfigurationForm = formGroupReducer(state.calendarConfigurationForm, action);
  state = {
    ...state,
    calendarConfigurationForm: validateCalendarConfigurationForm(calendarConfigurationForm)
  };
  return reducer(state, action);
}
